export default __webpack_public_path__ + "static/decor-707040bc4cee9ac68be69cc577ae6963.png";